<template>
    <b-button
        variant="primary"
        @click.stop="confirmarAtivarDesativarUsuario()"
        class="mr-2"
        >{{ operacaoBtn }} Usuário</b-button
    >
</template>

<script>
import UsuariosServicos from './UsuariosServicos'
import UsuariosFornecedorServicos from './UsuariosFornecedorServicos'
import FornecedoresUsuariosServicos from './../../fornecedor/usuarios/UsuariosServicos'

export default {
    props: {
        usuario: {
            type: Object,
            required: true
        },

        fornecedor: {
            type: Boolean,
            default: false
        },

        gestaoInterna: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            operacaoTitulo: '',
            operacaoTexto: '',
            operacaoBtn: ''
        }
    },

    methods: {
        confirmarAtivarDesativarUsuario() {
            this.$swal({
                title: `${this.operacaoTitulo} de Usuário`,
                html: `Confirma a ${this.operacaoTexto} do usuário <b>${this.usuario.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.ativarDesativarUsuario()
                }
            })
        },

        ativarDesativarUsuario() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.fornecedor) {
                promisse = FornecedoresUsuariosServicos.ativarDesativarUsuario(
                    this.$route.params.usuarioId
                )
            } else if (this.gestaoInterna) {
                promisse = UsuariosFornecedorServicos.ativarDesativarUsuario(
                    this.$route.params.fornecedorId,
                    this.$route.params.usuarioId
                )
            } else {
                promisse = UsuariosServicos.ativarDesativarUsuario(
                    this.$route.params.usuarioId
                )
            }
            promisse.then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$store.dispatch('setRecarregar', true)
                        this.$emit('obterUsuario')
                    } else {
                        this.$toast.error(
                            `Erro ao ${this.operacaoBtn} o usuário`,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    watch: {
        usuario() {
            if (this.usuario.status === 1 || this.usuario.status === 2) {
                this.operacaoTitulo = 'Desativação'
                this.operacaoTexto = 'desativação'
                this.operacaoBtn = 'Desativar'
            } else {
                this.operacaoTitulo = 'Ativação'
                this.operacaoTexto = 'ativação'
                this.operacaoBtn = 'Ativar'
            }
        }
    }
}
</script>
